<template>
  <section class="audio-detail">
    <!--<div class="audio-detail-scroller">-->
      <!--<div class="audio-detail-title">{{ dataSource.chapterTitle }}</div>-->
      <!--<div class="audio-detail-teacher" v-if="dataSource.teacherName">-->
        <!--<i :style="{ 'background-image': 'url(' + dataSource.teacherImage + ')', 'background-repeat':'no-repeat', 'background-size': 'cover' }"></i>-->
        <!--<span>讲师-{{ dataSource.teacherName }}</span>-->
      <!--</div>-->
      <div class="audio-detail-main">
        <div class="audio-detail-main-teacher">
          <img :src="dataSource.teacherImage" alt="">
        </div>
        <audio-controller
          :title="dataSource.chapterTitle"
          :teacher = "dataSource.teacherImage"
          :src="fixedUrl || dataSource.mediaUrl"
          :hasBuy="hasBuy"
          :quickChapterList="quickChapterList"
          :currentChapterIndex="currentChapterIndex"
          :played-time="dataSource.playLength"
          :length="dataSource.mediaLength"
          @changeBottom="changeBottom"
          @selectChapter="selectChapter"
          @error="onAudioError"
        >
          <!--<DetailChapter-->
          <!--:hasBuy="hasBuy"-->
          <!--:chapterList="chapterList"-->
          <!--:courseId="courseId"-->
          <!--:chapterIndex="currentChapterIndex"></DetailChapter>-->
        </audio-controller>
      </div>
      <div class="audio-detail-bar">
        <div class="audio-detail-bar-main" :class="{'tab-fixed': isTabFixed}" ref="bar">
          <span v-for="(item, index) in tabList"
                :class="{'active': tabIndex === index}"
                @click="handlerClick(index)"
                :key="item">
            {{item}}
          </span>
        </div>
      </div>
      <div class="audio-detail-content"
        v-if="!tabIndex"
        v-html="dataSource.content"></div>
      <div v-else class="audio-detail-comment">
        <comment-bar
          :quantity="totalCommentList.length"
          @comment="toggleCommentPopup" />
        <div class="audio-detail-comment-null" v-if="!totalCommentList.length">
          <img src="../assets/images/audio-comment-null.png" alt="">
        </div>
        <comment-box
          v-for="item in totalCommentList"
          :key="item.id"
          :comment="item" />
        <reply-popup
          v-if="comment.popup.show"
          v-model="comment.popup.content"
          :placeholder="comment.popup.placeholder"
          :cancel="toggleCommentPopup"
          :send="sendOneComment" />
      </div>

      <!-- 打卡    -->
      <!--<clock-in-->
          <!--v-if="!isApp&&clockInStatus.isSignCourse === 1"-->
          <!--class="audio-detail-clock"-->
          <!--:is-clock="clockInStatus.isSign === 1"-->
          <!--:dataSource="dataSource"-->
      <!--/>-->
      <!-- 提示弹窗 -->
      <!-- <notice v-show="clockInStatus.isSendNotify === 0&&!isApp&&clockInStatus.isSignCourse === 1" ref="notice">
        <div class="audio-detail-notice" v-if="!clockInStatus.encourageType">
          <h1>打卡规则</h1>
          <h5>尊敬的学员，课程上线打卡返学费功能，每天学习后打卡分享至朋友圈，即可全额返学费</h5>
          <p><i class="audio-detail-notice-index">1</i>学费以代金券的形式返还，代金券全场通用</p>
          <p><i class="audio-detail-notice-index">2</i>之前学习的章节可以补打卡，全部补完后即可返还学费。</p>
          <div @click="closeNotice" class="audio-detail-notice-btn">知道了</div>
        </div>
        <div class="audio-detail-notice" v-else>
          <h1>打卡规则</h1>
          <h5>尊敬的学员，课程上线打卡返红包功能</h5>
          <p><i class="audio-detail-notice-index">1</i>每天学习后打卡分享至朋友圈，即可领取现金红包！</p>
          <p><i class="audio-detail-notice-index">2</i>一天最多可返一次哦！</p>
          <div @click="closeNotice" class="audio-detail-notice-btn">知道了</div>
        </div>
      </notice> -->
      <!-- 签到 -->
      <!-- <sign-in
        v-if="signStatus !== -1"
        :is-signed="signStatus === 1"
        @click="sign" /> -->
    <!--</div>-->
    <!-- <DetailBottom
      v-if="!dataSource.isRadioCourse"
      class="audio-detail-bottom"
      :is-clock="clockInStatus.isSign === 1"
      :hasBuy="hasBuy"
      :data-source="dataSource"
      :isBottomShow="isBottomShow">
    </DetailBottom> -->
    <!-- <notice class="weixin-notice" ref="weixin" :closeBtn="true" width="530" height="520">
      <div class="weixin-notice-main">
        <h1>扫码下方小程序立即提问</h1>
        <img  class="weixin-notice-main-code" src="//cdn.iciba.com/www/img/edu-m/question-code.jpeg" alt="">
        <img src="//cdn.iciba.com/www/img/edu-m/question-code.jpeg" alt="">
        <p>长按识别小程序码</p>
      </div>
    </notice> -->
    <div class="audio-detail-packet"
         v-if="!isApp && dataSource.canAsk">
      <div class="audio-detail-packet-close" @click="dataSource.canAsk = !dataSource.canAsk">x</div>
      <img @click="$refs.weixin.show()" :src="dataSource.askIcon" alt="">
    </div>
  </section>
</template>

<script>
import keys from 'lodash.keys'
import os from '@edu-fe/os'
import api from '@edu-fe/api'
import module from '../modules/audio-detail'
import moduleComment from '../modules/comment'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { CommentBox, CommentBar, ReplyPopup } from '../components/Comment'
import AudioController from '../components/AudioController'
// import DetailBottom from '../components/Detail/DetailBottom'
import DetailChapter from '../components/Detail/DetailChapter'
import SignIn from '../components/SignIn.vue'
import ShareMaker from '../lib/shareMaker'
import { isxxx } from '@mixins'
import ClockIn from '../components/ClockIn.vue'
// import Notice from '../components/Notice.vue'
import { setTimeout } from 'timers'
import record, { clearTimer } from '../lib/record'

const moduleCommentPath = `${module.name}/${moduleComment.name}`

export default {
  name: 'AudioDetail',
  data () {
    return {
      isBottomShow: true,
      tabList: ['课程文稿', '精选留言'],
      tabIndex: 0,
      tab: null,
      tabPos: 0,
      isTabFixed: false,
      fixedUrl: '' // 报错后使用的播放地址
    }
  },

  computed: {
    ...mapState(module.name, keys(module.state())),
    ...mapState(module.name, keys(module.modules)),
    ...mapGetters(module.name, keys(module.getters)),
    ...mapGetters(moduleCommentPath, keys(moduleComment.getters)),
    ...mapState(['isPrivilege', 'userInfo']),
    buyCard() {
      return this.$refs.buyCard
    },
    courseId () {
      return this.$route.query.courseId
    }
  },

  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapMutations(moduleCommentPath, keys(moduleComment.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    ...mapActions(moduleCommentPath, keys(moduleComment.actions)),
    changeBottom () {
      this.isBottomShow = !this.isBottomShow
    },
    // closeNotice() {
    //   this.$refs.notice.close();
    // },
    goto () {
      setTimeout(()=>{
        this.$router.push('/vip?from=H5_VIP')
      },300)
    },
    toActivityPage () {
      window.location.href = `https://edu-activity.wps.cn/activity/pull-new?courseId=${this.courseId}&from=laodaixin-gif`
    },
    selectChapter (chapter, index) {
      // barBus.$emit('stopRecord')
      // 未购买且非试看, 不可点击
      if (!this.hasBuy && chapter.canTry !== 1) {
        this.$toast.show({
          message: '请先购买课程'
        })
        return
      }
      if (chapter.liveState === -1) { // 非直播课
        if (chapter.isPublished) {
          // 区分音/视频详情
          switch (chapter.mediaType) {
            case 1: // 视频
              this.$router.replace(`/video-detail?courseId=${this.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`)
              break
            case 2: // 音频
              this.getMediaData({ chapterId: chapter.id, _this: this })
              this.changeQuickList({ chapterId: chapter.id })
              record.changeChapter(chapter.id)
              this.$router.replace(`/audio-detail?courseId=${this.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`)
              break
          }
        }
      } else { // 直播课
        this.$router.replace(`/live?chapterId=${chapter.id}`)
      }
    },
    handlerClick (index) {
      this.tabIndex = index
    },
    async onAudioError (err) {
      // m3u8音频格式无法播放时, 请求mp3格式url
      this.fixedUrl = (await api.media.getMediaData({
        chapterId: this.dataSource.chapterId,
        client: 1 // client为1时, 后台数据不可靠, 但mediaUrl是源mp3
      })).data.mediaUrl
    }
  },

  watch: {
    dataSource (data) {
      // window.history.replaceState({}, document.title, this.landingPage)
      const href = `${location.protocol}//${location.host}${this.$route.fullPath}`
      setTimeout(() => {
        // return new ShareMaker(Object.assign(data, { userId: this.userInfo.userId }), href)
        return new ShareMaker({
          title: '微课',
          introduction: data.courseName || data.chapterTitle,
          imgUrl: this.$store.state.organizationMessage.organLogo,
          link: window.location.href
        }, href, true)
      }, 300);
    }
  },

  mixins: [
    isxxx
  ],

  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    this.init(this)
  },
  async mounted() {
  },
  updated () {
    this.$nextTick(_ => {
      if (this.tab) {
        this.tab = this.$refs.bar
        this.tabPos = this.tab.offsetTop
        // this.$refs.notice.show();
        window.addEventListener('scroll', () => {
          if (window.pageYOffset > this.tabPos) {
            this.isTabFixed = true
          } else {
            this.isTabFixed = false
          }
        })
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    clearTimer()
    next()
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },

  components: {
    AudioController,
    SignIn,
    CommentBox,
    CommentBar,
    ReplyPopup,
    ClockIn,
    // Notice,
    // DetailBottom,
    DetailChapter
  }
}
</script>

<style lang="scss">
@charset 'utf-8';
@import '../style/main';

.audio-detail {
  box-sizing: border-box;
  /*height: 100vh;*/
  /*overflow: scroll;*/
  padding-bottom: rem(160);
  &-bar {
    height: rem(88);
    .tab-fixed {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 999;
      background-color: #ffffff;
    }
    &-main {
      display: flex;
      justify-content: space-around;
      height: rem(88);
      line-height: rem(88);
      font-size: rem(32);
      color: #666666;
      box-shadow: #F7F7F7 0 rem(4) rem(8) 0;
      .active {
        color: $globalColor;
        font-weight: bold;
        position: relative;
        &:after {
          content: '';
          display: block;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: rem(60);
          height: rem(6);
          border-radius: rem(5);
          background: $globalColor
        }
      }
    }
  }
  &-main {
    font-size: 0;
    background-color: #7e6c5b;
    height: rem(698);
    &-teacher {
      padding-top: rem(60);
      text-align: center;
      > img {
        width: rem(232);
        height: rem(285);
      }
    }
  }
  .weixin-notice {
    &-main{
      position: relative;
      padding: rem(60);
      img {
        width: rem(240);
      }
      &-code {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        z-index: 1;
      }
      h1 {
        font-size: rem(36);
        color: #333333;
        font-weight: bold;
        margin-bottom: rem(40);
      }
      p {
        font-size: rem(28);
        margin-top: rem(40);
        color: #999999;
      }
    }
  }
  &-packet {
    position: fixed;
    bottom: rem(146);
    right: rem(20);
    &-close {
      font-size: rem(20);
      width: rem(24);
      height: rem(24);
      line-height: rem(24);
      text-align: center;
      border-radius: 100%;
      color: #999999;
      border: 1px solid #999999;
      position: absolute;
      right: rem(-10);
      top: rem(-10);
    }
    > img {
      width: rem(104);
    }
  }
  // &-scroller {
    // box-sizing: border-box;
    // overflow-y: scroll;
    /*padding-bottom: rem(160);*/
    // height: 100%;
  // }

  &-title {
    padding: rem(25) rem(30) rem(15);
    line-height: 1.5;
    font-size: rem(46);
    color: #444;
    font-weight: bold;
  }

  &-teacher {
    padding: 0 rem(30);
    font-size: rem(26);
    color: #999;

    & > i {
      $size: rem(40);

      display: inline-block;
      vertical-align: middle;
      margin-right: rem(15);
      width: $size;
      height: $size;
      border-radius: 50%;
      background-size: contain;
    }
  }

  &-content {
    position: relative;
    margin-top: rem(30);
    padding: 0 rem(30);

    & > img {
      display: block;
      width: 100%;
    }
    & > &-null {
      width: rem(530);
      margin: rem(80) auto auto;
    }
  }

  &-comment {
    .commentBar {
      margin-bottom: use(30);
    }
    .commentBox {
      margin: 0 auto;
    }
    &-null {
      width: 100%;
      text-align: center;
      > img {
        width: rem(530);
      }
    }
  }

  &-clock{
    position: fixed;
    bottom: use(160);
    right: use(40);
  }
  &-notice{
    padding: use(70) use(38) 0;
    box-sizing: border-box;
    text-align: left;
    h1{
      font-size: use(38);
      color: #444444;
      text-align: center;
      line-height: 1;
      margin: 0 auto use(45);
    }
    h5{
      font-size: use(30);
      font-weight: lighter;
      color: #555555;
      line-height: use(44);
      margin-bottom: use(30);
    }
    p{
      font-size: use(30);
      font-weight: lighter;
      color: #555555;
      line-height: use(44);
      margin-bottom: use(28);
      overflow: hidden;
    };
    p:first-child{
      font-weight: normal;
    };
    &-index{
      float: left;
      width: use(42);
      height: use(42);
      margin: use(3) use(18) use(44) 0;
      background: rgba(244,142,1,0.20);
      font-size: use(26);
      line-height: use(42);
      color: $globalColor;
      text-align: center;
      border-radius: 50%;
    }
    &-btn{
      font-size: use(34);
      color: $globalColor;
      text-align: center;
      line-height: use(90);
      margin-top: use(70);
      border-top: use(1) solid #E4E4E4;
    }

  }
  &-bottom {
    position: relative;
    z-index: 99;
  }
}
</style>
